import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, ISkillCategoriesDropdown, IStateMastDropdown, IUniversityDropdown, IVisaDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { CblType, Experience, NoticePeriod, TaxTerm } from "../../models/FDropdown";
import { AutoComplete } from "primereact/autocomplete";
import { IClientContactPerson } from "../../models/ClientContactPerson";
import { FileUpload, FileUploadHandlerParam } from 'primereact/fileupload';
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVInputCheck } from "../../shared/JVInputCheck";
import { IConsultantMast } from "../../models/ConsultantMast";
import { Dialog } from "primereact/dialog";

interface IProps {
    open: boolean,
    singleData: any,
    onHide: () => void,
    toast: any,
}

export interface ICconsultantHotList {
    consultant_ID?: number, //cm
    consultant_Name?: string, //cm
    consultant_Email_ID?: string, //cm
    consultant_Home_No?: string, //cm
    consultant_Job_Title?: string, //cm
    visa_Status?: number, //cm
    consultant_State?: string, //cm
    consultant_City?: number, //cm
    total_Experience?: number, //cm
    linkedin?: string, //cm
    availability?: string, //cm
    hourly_Rate?: number, //cm
    concent?: string, //cm
    mathingProfilePer?: number, //cm
    dobdd?: string, //cm
    dobmm?: string, //cm
    dobyyyy?: string, //cm
    dob?: string, //cm
    ssn?: string, //cm
    annual_Salary?: number, //cm
    consultant_Country?: number, //cm
    state_Name?: string,
    city_Name?: string,
    degree?: string, //ce
    passoutYear?: string, //ce
    country_Name?: string, //ce
    university_ID?: number,
    university_Name?: string,
    tax_Term?: string, //csl
    payment_Term?: number | null,
    faceToFaceInterview?: string, //csl
    addition_Info?: string, //csl
    submissionType?: string, //csl
    buying_Rate?: string, //csl
    submittal_Rate?: string, //csl
    vendor_Company_Name?: string
    contact_Person_EmailID?: string, //scp
    vendor_Company_ID?: number, //scp
    contact_Person_Name?: string, //scp
    phone_No?: string, //scp
    requirement_ID?: number,

    consultant_Resume_Path?: string,
    createdOn?: Date,
    consultant_Added_ByUser?: number,
    consultant_Status?: string,

    city?: ICityMastDropdown,
    state?: IStateMastDropdown,
    country?: ICountryMastDropdown,
    company?: IClientCompanyDropdown | null,
    university?: IUniversityDropdown,
    status?: string,
    reLocation?: string,
    skillCategoryID?: number,
}

const schema = yup.object({
    consultant_Name: yup.string().required("Consultant Name is required*"),
    consultant_Email_ID: yup.string().required("Consultant Email is required*").email(),
    consultant_Home_No: yup.string().required("Consultant Home No is required*"),
    consultant_Job_Title: yup.string().required("Job Title is required*"),
    skillCategoryID: yup.number().required("Skill Category is required*"),
    visa_Status: yup.number().min(1).required("visa Status is required*"),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    total_Experience: yup.number().required("Total Experience is required*"),
    availability: yup.string().required("Availability is required*"),
    faceToFaceInterview: yup.string().required("Face To Face Interview is required*"),
    hourly_Rate: yup.number().required("Hourly Rate is required*"),
    tax_Term: yup.string().required("Tax Term is required*"),
    // payment_Term:yup.number().required(),
    // required if tax_Term = "C2C with Benefits";
    payment_Term: yup.number().when('tax_Term', val => {
        return (val === "1099 All Inclusive" || val === "1099 with Benefits" || val === "W2 All Inclusive" || val === "W2 with Benefits") ?
            yup.number().min(1).required("Payment Term is Required").nullable() :
            yup.number().nullable();
    }),
    status: yup.string().required("Status is required*"),
    reLocation: yup.string().required("ReLocation is required*"),
    contact_Person_EmailID: yup.string().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.string().email().required() :
            yup.string().nullable();
    }),
    company: yup.object().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.object().shape({
                vendor_Company_ID: yup.number().min(1, "Employer Company is required*").required("Employer Company is required*"),
                vendor_Company_Name: yup.string().required()
            }) :
            yup.object().shape({
                vendor_Company_ID: yup.number().nullable(),
                vendor_Company_Name: yup.string().nullable(),
            }).nullable();
    }),
    contact_Person_Name: yup.string().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.string().required() :
            yup.string().nullable();
    }),
    phone_No: yup.string().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.string().required() :
            yup.string().nullable();
    }),

    degree: yup.string().nullable(),
    university_Name: yup.string().nullable(),
    passoutYear: yup.string().nullable(),
    country: yup.object().shape({
        country_ID: yup.number(),
        country_Name: yup.string()
    }).nullable(),
    // dob: yup.string(),
    ssn: yup.string().nullable(),
    linkedin: yup.string().url().nullable(),
    submissionType: yup.string().nullable(),
    annual_Salary: yup.string().nullable(),
});

const emailSchema = yup.object().shape({
    email: yup.string().required().email()
});

const idSchema = yup.object().shape({
    id: yup.number().required().min(1)
});

const PaymentTerm = [
    { name: "By Weekly", value: 1 },
    { name: "Net Fifteen", value: 2 },
    { name: "Net Thirty", value: 3 },
    { name: "Net Forty Five", value: 4 },
    { name: "Net Sixty", value: 5 },
];

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [universities, setUniversities] = useState<Array<IUniversityDropdown>>();
    const [university, setUniversity] = useState<IUniversityDropdown | undefined | string>(undefined);
    const [resume, setResume] = useState(false);
    const [additionInfo, setAdditionInfo] = useState("");
    const [disableEmployeeDetails, setDisableEmployeeDetails] = useState(false);
    const [disablePaymentsTerm, setDisablePaymentsTerm] = useState(true);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const [disableConsultant, setDisableConsultant] = useState(true);
    const [submissionType, setSubmissionType] = useState<number | null>(null);
    const [employerDetails, setEmployerDetails] = useState({ data: [], open: false, consultant_ID: 0 } as { data: Array<any>, open: boolean, consultant_ID: number | undefined });
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();

    const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm<ICconsultantHotList>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
        defaultValues: {}
    });

    const onSubmit = (data: ICconsultantHotList) => {
        if (resumeFile === null && (props.singleData.consultant_ID === undefined || props.singleData.consultant_ID === null)) {
            props.toast.current.show({ severity: 'error', content: "Please Upload Resume", life: 3000 });
        } else {
            onSave(data);
        }
    }

    const onSave = async (body: ICconsultantHotList) => {
        setLoading(true);

        let newConsultant: any = {
            consultant_Name: body.consultant_Name,
            consultant_Email_ID: body.consultant_Email_ID,
            consultant_Home_No: body.consultant_Home_No,
            consultant_Job_Title: body.consultant_Job_Title,
            skillCategoryID: body.skillCategoryID,
            visa_Status: body.visa_Status,
            state_ID: body.state?.state_ID,
            city_ID: body.city?.city_ID,
            total_Experience: body.total_Experience,
            availability: body.availability,
            hourly_Rate: body.hourly_Rate,
            tax_Term: body.tax_Term,
            payment_Term: body.payment_Term,
            status: body.status,
            faceToFaceInterview: body.faceToFaceInterview,
            reLocation: body.reLocation,

            contact_Person_EmailID: body.contact_Person_EmailID,
            vendor_Company_ID: body.company?.vendor_Company_ID,
            contact_Person_Name: body.contact_Person_Name,
            phone_No: body.phone_No,

            degree: body.degree,
            university_Name: body.university_Name,
            passoutYear: body.passoutYear,
            country_ID: body.country?.country_ID,
            dob: (body.dobyyyy && body.dobmm && body.dobdd) ? new Date(Number(body.dobyyyy), Number(body.dobmm) - 1, Number(body.dobdd)) : null,
            ssn: body.ssn,
            linkedin: body.linkedin,
            submissionType: body.submissionType,
            annual_Salary: body.annual_Salary,
        };

        if (props.singleData.consultant_ID) {
            newConsultant.consultant_ID = props.singleData.consultant_ID;
        }

        // if (body.dobdd === undefined) body.dobdd = "";
        // if (body.dobmm === undefined) body.dobmm = "";
        // if (body.dobyyyy === undefined) body.dobyyyy = "";
        // const consultant_Mast: IConsultantMast = {
        //     consultant_ID: body.consultant_ID,
        //     consultant_Name: body.consultant_Name,
        //     consultant_Email_ID: body.consultant_Email_ID,
        //     consultant_Home_No: body.consultant_Home_No,
        //     consultant_Job_Title: body.consultant_Job_Title,
        //     visa_Status: body.visa_Status,
        //     consultant_State: body.state?.state_Name,
        //     consultant_City: body.city?.city_ID,
        //     total_Experience: body.total_Experience,
        //     availability: body.availability,
        //     hourly_Rate: body.hourly_Rate,
        //     dob: body.dobmm + "-" + body.dobdd + "-" + body.dobyyyy,
        //     ssn: body.ssn,
        //     linkedin: body.linkedin,
        //     consultant_Country: body.country?.country_ID,
        //     annual_Salary: body.annual_Salary ? body.annual_Salary : undefined,
        //     consultant_Status: body.university_Name
        // }
        // const consultant_Education_Details: IConsultantMast = {
        //     degree: body.degree,
        //     university_Name: body.university_Name,
        //     passoutYear: body.passoutYear,
        //     country: body.country,
        //     dob: `${body.dobyyyy}-${body.dobmm}-${body.dobdd}`,
        //     ssn: body.ssn,
        //     linkedin: body.linkedin,
        //     submissionType: body.submissionType,
        //     annual_Salary: body.annual_Salary
        // }
        // const consultant_Submittal_Logs: IConsultantMast = {
        //     // requirement_ID: props.singleData.req_ID,
        //     faceToFaceInterview: body.faceToFaceInterview,
        //     tax_Term: body.tax_Term,
        //     payment_Term: body.payment_Term,
        //     submissionType: body.submissionType,
        //     buying_Rate: body.hourly_Rate?.toString(),
        //     addition_Info: additionInfo
        // }
        // const sub_Vendor_Contact_Person_Mast: IConsultantMast = {
        //     contact_Person_EmailID: body.contact_Person_EmailID,
        //     contact_Person_Name: body.contact_Person_Name,
        //     phone_No: body.phone_No,
        //     vendor_Company_ID: body.company?.vendor_Company_ID
        // }

        // const consultant1 = {
        //     consultant_Mast,
        //     consultant_Education_Details,
        //     consultant_Submittal_Logs,
        //     sub_Vendor_Contact_Person_Mast
        // }

        // console.log(consultant1);

        const formData = new FormData();
        formData.append('resume', resumeFile);
        formData.append('consultant1', JSON.stringify(newConsultant));
        const params = {
            method: props.singleData.consultant_ID ? "PUT" : "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}ConsultantHotList`, params);

        if (response.ok) {
            props.toast.current.show({ severity: 'success', detail: "Consultant Hot List Created Successfully", life: 3000 });
            setResume(false);
            reset({});
            setResumeFile(null);
            props.onHide();
        } else if (response.status === 400) {
            const message = await response.text();
            props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            setLoading(false);
        }
        setLoading(false);
    };

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            // props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadUniversities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/universities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IUniversityDropdown> = await response.json();
            setUniversities(prev => prev = data);
        }
    }
    const completeMethodUniversities = (event: { query: string }) => {
        loadUniversities(event.query);
    }

    const loadCountries = async (filter: string | null) => {
        const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICountryMastDropdown> = await response.json();
            setCountries(data);
        }
    }
    const completeMethodCountries = (event: { query: string }) => {
        loadCountries(event.query);
    }

    const fillSubVendor = async () => {
        setLoading(true);
        if (control._formValues.contact_Person_EmailID === "") return;
        const email = control._formValues.contact_Person_EmailID;
        if (!(email?.includes("gmail") || email?.includes("outlook")
            || email?.includes("protonmail") || email?.includes("aol")
            || email?.includes("yahoo") || email?.includes("hotmail")
            || email?.includes("rediff"))) {
            const valid = await emailSchema.isValid({
                email: control._formValues.contact_Person_EmailID,
            });
            if (valid) {
                const response = await Fetch("Sub_Vendor_Contact_Person_Mast/email", "GET", null, `email=${control._formValues.contact_Person_EmailID}`, props.toast);
                if (response) {
                    const data: Array<IClientContactPerson> = await response.json();

                    if (data.length > 0) {
                        setValue("contact_Person_EmailID", data[0].contact_Person_EmailID);
                        setValue("contact_Person_Name", data[0].contact_Person_Name);
                        setValue("phone_No", data[0].phone_No);
                        setValue("vendor_Company_ID", data[0].vendor_Company_ID);
                        setValue("company", { vendor_Company_ID: data[0].vendor_Company_ID, vendor_Company_Name: data[0].vendor_Company_Name });
                    } else {
                        setValue("contact_Person_Name", '');
                        setValue("phone_No", undefined);
                        setValue("vendor_Company_ID", undefined);
                        setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
                        props.toast.current.show({ severity: 'info', content: "No Employer Found resistered with this Email-ID" });
                    }
                }
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Employer Email-ID" });
        } else {
            setValue("contact_Person_Name", '');
            setValue("phone_No", undefined);
            setValue("vendor_Company_ID", undefined);
            setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
            props.toast.current.show({ severity: 'error', content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
        }
        setLoading(false);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies_emp_details", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const resumeUploade = (event: FileUploadHandlerParam) => {
        const file = event.files[0];
        if (event.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                // console.log(event.files[0].size);
                props.toast.current.show({ severity: 'error', content: "DOCX File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResume(true);

                setResumeFile(file);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A DOCX File." });
            event.options.clear();
        }
        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Resume Selecetd", life: 3000 });
        setResume(true);

    };

    const fillSubmission = async () => {
        setResume(false)
        if (control._formValues.identityType === "Email ID") {
            const valid = await emailSchema.isValid({
                email: control._formValues.identity,
            });
            if (valid) {
                const email = control._formValues.identity;
                fillSub(email, false);
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Email-ID" });
        } else if (control._formValues.identityType === "Cons. ID") {
            const valid = await idSchema.isValid({
                id: control._formValues.identity,
            });
            if (valid) {
                const id = control._formValues.identity;
                fillSub(id, true);

            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Consultant-ID" });
        }
    }

    const fillSub = async (identity: string, isID: boolean) => {

        setLoading(true);
        let query = `req_id=${0}&`;
        if (isID) query += `consultant_id=${control._formValues.identity}`;
        else query += `consultant_email=${control._formValues.identity}`;
        setUniversity(undefined);

        // const responseSub = await Fetch("Consultant_Mast/consultantSub", "GET", null, query, props.toast);
        // if (responseSub) {
        //     const data: Array<IConsSubmission> = await responseSub.json();
        //     setSubTable({ data: data, open: subTable.open });
        //     //setEmployerDetails({ data: data, open: employerDetails.open });
        // }
        const response = await Fetch("Consultant_Mast", "GET", null, query, props.toast);
        if (response) {
            const _data: Array<IConsultantMast> = await response.json();
            // console.log(_data);
            const data = _data[0];
            setEmployerDetails({ data: _data, open: employerDetails.open, consultant_ID: data.consultant_ID });

            setSubmissionType(data?.consultant_ID ?? null);

            if (data.consultant_Status !== "00.01" && data.consultant_Status !== "00.02") {
                reset(data);
                setDisableConsultant(true);

                // setValue("identity", data.consultant_Email_ID);
                setValue("state", { state_ID: 1, state_Name: data.consultant_State });
                setValue("city", { city_ID: data.consultant_City || 0, city_Name: data.city_Name || "" });
                setValue("country", { country_ID: data.consultant_Country, country_Name: data.country_Name });
                setValue("company", { vendor_Company_ID: data.vendor_Company_ID, vendor_Company_Name: data.vendor_Company_Name });
                setValue("faceToFaceInterview", "No");
                setValue("tax_Term", "C2C with Benefits");
                setUniversity({ university_ID: data.university_ID, university_Name: data.university_Name });
                const _dobArray = data.dob?.split("-");
                if (_dobArray) {
                    setValue("dobmm", _dobArray[0]);
                    setValue("dobdd", _dobArray[1]);
                    setValue("dobyyyy", _dobArray[2]);
                }
            } else {
                reset({});
                setDisableConsultant(false);
                // setValue("identity", identity);
                !isID && setValue("consultant_Email_ID", identity);
                props.toast.current.show({ severity: 'info', content: data.consultant_Job_Title });
            }
        }
        setLoading(false);
    }

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            setSkillCategories(data);
        }
    }

    const onHide = () => {
        setLoading(false);
        setDisableEmployeeDetails(false);
        setDisablePaymentsTerm(true);
        setResumeFile(null);
        reset({});
        setResume(false);
        props.onHide();
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "tax_Term") {
                if (value.tax_Term === "C2C with Benefits" || value.tax_Term === "C2C All Inclusive") {
                    setDisableEmployeeDetails(false);
                } else {
                    setDisableEmployeeDetails(true);
                }
            }
            if (name === "tax_Term") {
                if (value.tax_Term === "1099 All Inclusive" || value.tax_Term === "1099 with Benefits" || value.tax_Term === "W2 All Inclusive" || value.tax_Term === "" || value.tax_Term === "W2 with Benefits") {
                    setDisablePaymentsTerm(false)
                } else {
                    setDisablePaymentsTerm(true)
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (university) {
            let un: string | undefined = undefined;
            if (typeof (university) === 'string') {
                un = university;
            } else {
                un = university?.university_Name;
            }
            setValue("university_Name", un);
        } else {
            setValue("university_Name", undefined);
        }
        // console.log(university, control._formValues.university_Name);
    }, [university]);

    useEffect(() => {
        loadVisa();
        loadSkillCategories();
        if (props.open && props.singleData.consultant_ID) {

            let bodyData: any = props.singleData;
            bodyData.state = {
                state_ID: props.singleData.state_ID,
                state_Name: props.singleData.state_Name
            };
            bodyData.city = {
                city_ID: props.singleData.city_ID,
                city_Name: props.singleData.city_Name
            };
            bodyData.visa_Status = props.singleData.visa_Status;
            if (props.singleData.country_ID !== undefined && props.singleData.country_ID !== null && props.singleData.country_ID !== 0) {
                bodyData.country = {
                    country_ID: props.singleData.country_ID,
                    country_Name: props.singleData.country_Name
                };
            } else {
                bodyData.country = null;
            }
            bodyData.dobmm = props.singleData.dob ? `${new Date(props.singleData.dob || "").getMonth() < 10 ? '0' + `${new Date(props.singleData.dob || "").getMonth()}` : new Date(props.singleData.dob || "").getMonth()}` : null;
            bodyData.dobdd = props.singleData.dob ? `${new Date(props.singleData.dob || "").getDay() < 10 ? '0' + `${new Date(props.singleData.dob || "").getDay()}` : new Date(props.singleData.dob || "").getDay()}` : null;
            bodyData.dobyyyy = props.singleData.dob ? `${new Date(props.singleData.dob || "").getFullYear()}` : null;
            bodyData.tax_Term = props.singleData.tax_Term;
            if (props.singleData.tax_Term === "C2C with Benefits" || props.singleData.tax_Term === "C2C All Inclusive") {
                setDisableEmployeeDetails(prev => prev = false);
                bodyData.contact_Person_Name = props.singleData.contact_Person_Name;
                bodyData.company = {
                    vendor_Company_ID: props.singleData.vendor_Company_ID,
                    vendor_Company_Name: props.singleData.vendor_Company_Name
                };
                bodyData.phone_No = props.singleData.phone_No;
            } else {
                setDisableEmployeeDetails(prev => prev = true);
                delete bodyData.company;
                delete bodyData.contact_Person_Name;
                delete bodyData.phone_No;
            }
            bodyData.university_Name = props.singleData.university_Name;

            if (props.singleData.contact_Person_EmailID !== undefined || props.singleData.contact_Person_EmailID !== null || props.singleData.contact_Person_EmailID !== "") bodyData.contact_Person_EmailID = props.singleData.contact_Person_EmailID;
            else delete bodyData.contact_Person_EmailID;

            if (props.singleData.contact_Person_Name !== undefined || props.singleData.contact_Person_Name !== null || props.singleData.contact_Person_Name !== "") bodyData.contact_Person_Name = props.singleData.contact_Person_Name;
            else delete bodyData.contact_Person_Name;

            if (props.singleData.phone_No === undefined || props.singleData.phone_No === null || props.singleData.phone_No === "") delete bodyData.phone_No;
            else bodyData.phone_No = props.singleData.phone_No;

            if (props.singleData.tax_Term === "C2C with Benefits" || props.singleData.tax_Term === "C2C All Inclusive") {
                setDisableEmployeeDetails(prev => prev = false);
                bodyData.contact_Person_Name = props.singleData.contact_Person_Name;
                bodyData.company = {
                    vendor_Company_ID: props.singleData.vendor_Company_ID,
                    vendor_Company_Name: props.singleData.vendor_Company_Name
                };
                bodyData.phone_No = props.singleData.phone_No;
            } else {
                setDisableEmployeeDetails(prev => prev = true);
                delete bodyData.contact_Person_EmailID;
                delete bodyData.company;
                delete bodyData.contact_Person_Name;
                delete bodyData.phone_No;
            };

            if (props.singleData.degree === undefined || props.singleData.degree === null || props.singleData.degree === "") delete bodyData.degree;

            if (props.singleData.university_Name === undefined || props.singleData.university_Name === null || props.singleData.university_Name === "") delete bodyData.university_Name;
            else bodyData.university_Name = props.singleData.university_Name;

            if (props.singleData.passoutYear === undefined || props.singleData.passoutYear === null || props.singleData.passoutYear === "") delete bodyData.passoutYear;
            else bodyData.passoutYear = props.singleData.passoutYear;

            if (props.singleData.country_ID !== undefined && props.singleData.country_ID !== null && props.singleData.country_ID !== 0) {
                bodyData.country = {
                    country_ID: props.singleData.country_ID,
                    country_Name: props.singleData.country_Name
                };
            } else delete bodyData.country;

            if (props.singleData.dob !== undefined && props.singleData.dob !== null && props.singleData.dob !== "") {
                bodyData.dobmm = props.singleData.dob ? `${new Date(props.singleData.dob || "").getMonth() < 10 ? '0' + `${new Date(props.singleData.dob || "").getMonth()}` : new Date(props.singleData.dob || "").getMonth()}` : null;
                bodyData.dobdd = props.singleData.dob ? `${new Date(props.singleData.dob || "").getDay() < 10 ? '0' + `${new Date(props.singleData.dob || "").getDay()}` : new Date(props.singleData.dob || "").getDay()}` : null;
                bodyData.dobyyyy = props.singleData.dob ? `${new Date(props.singleData.dob || "").getFullYear()}` : null;
            } else {
                delete bodyData.dobmm;
                delete bodyData.dobdd;
                delete bodyData.dobyyyy;
            }

            if (props.singleData.ssn !== undefined && props.singleData.ssn !== null && props.singleData.ssn !== 0) bodyData.ssn = props.singleData.ssn;
            else delete bodyData.ssn;

            if (props.singleData.linkedin !== undefined && props.singleData.linkedin !== null && props.singleData.linkedin !== "") bodyData.linkedin = props.singleData.linkedin;
            else delete bodyData.linkedin;

            if (props.singleData.submissionType !== undefined && props.singleData.submissionType !== null && props.singleData.submissionType !== 0) bodyData.submissionType = props.singleData.submissionType;
            else delete bodyData.submissionType;

            bodyData.annual_Salary = props.singleData.annual_Salary || 0;

            if (props.singleData.university_Name !== null && props.singleData.university_Name !== undefined && props.singleData.university_Name.trim() !== "") {
                loadUniversities(props.singleData.university_Name);
            }
            reset(bodyData);
            setValue('tax_Term', props.singleData.tax_Term);
        } else if (props.open) {
            reset(props.singleData);
        }
    }, [props.open]);

    useEffect(() => {
        if (props.open && props.singleData !== undefined && props.singleData.university_Name !== null && props.singleData.university_Name !== undefined && props.singleData.university_Name.trim() !== "") {
            setUniversity((universities || []).filter(e => e.university_Name === props.singleData.university_Name)[0]);
        }
    }, [props.open, universities]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Consultant" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="p-fluid formgrid grid">
                        <JVDropdown column={3} control={control} name="identityType" options={[
                            { name: "Email ID" },
                            { name: "Cons. ID" }
                        ]} optionLabel="name" optionValue="name" placeholder="--Select--" />
                        <JVInputCheck required func={fillSubmission} control={control} name="identity" />
                    </div>
                    <Accordion multiple activeIndex={[0, 1]}>
                        <AccordionTab header="Consultant Required Details:">
                            <div className="p-fluid formgrid grid">
                                <JVInput required label="Consultant Name" placeholder="Consultant Name" column={3} control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
                                <JVInput required label="Email" placeholder="Email" column={3} control={control} name="consultant_Email_ID" error={errors.consultant_Email_ID?.message} />
                                <JVInputMask required mask="(999) 999-9999" column={3} label="Phone" placeholder="Phone" control={control} name="consultant_Home_No" error={errors.consultant_Home_No?.message} />
                                <JVInput required label="Job Title" placeholder="Job Title" column={3} control={control} name="consultant_Job_Title" error={errors.consultant_Job_Title?.message} />
                                <JVDropdown required column={3} label="Skills Category" control={control} name="skillCategoryID" error={errors.skillCategoryID?.message} options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Skills Category" />


                                <JVDropdown required column={3} label="Visa" control={control} name="visa_Status" error={errors.visa_Status?.message} options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="--Select Visa--" />
                                <JVDropdownInput required column={3} completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                                <JVDropdownInput required column={3} completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />

                                <JVDropdown required column={3} label="Total Experience (In Years)" control={control} name="total_Experience" error={errors.total_Experience?.message} options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

                                <JVDropdown required column={3} label="Availability" control={control} name="availability" error={errors.availability?.message} options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />

                                <JVInput required placeholder="Buying Rate" label="Buying Rate" type={"number"} column={3} control={control} name="hourly_Rate" error={errors.hourly_Rate?.message} />
                                <JVDropdown required column={3} control={control} label="Tax Term" name="tax_Term" error={errors.tax_Term?.message} options={TaxTerm} optionLabel="name" optionValue="name" placeholder="--Select TaxTerm--" />
                                {!disablePaymentsTerm && <JVDropdown required column={3} disabled={disablePaymentsTerm} control={control} label="Payment Term" name="payment_Term" error={errors.payment_Term?.message} options={PaymentTerm} optionLabel="name" optionValue="value" placeholder="--Select PaymentTerm--" />}
                                <JVDropdown column={3} label="Consultant Status" control={control} name="status" error={errors.status?.message} options={[{ name: "Active" }, { name: "InActive" }, { name: "Hold" }]} optionLabel="name" optionValue="name" placeholder="--Select Status--" />
                                <JVRadioBtn inline label="F2F Interview" required data={["Yes", "No"]} column={3} control={control} name="faceToFaceInterview" error={errors.faceToFaceInterview?.message} />
                                <JVRadioBtn inline label="ReLocation" required data={["Yes", "No"]} column={3} control={control} name="reLocation" error={errors.reLocation?.message} />
                            </div>
                        </AccordionTab>

                        {!disableEmployeeDetails && <AccordionTab header="Employer Details:">
                            <div className="p-fluid formgrid grid">
                                <JVInput required disabled={disableEmployeeDetails} label="Employer Email" onBlur={fillSubVendor} placeholder="Employer Email" column={4} control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />
                                <JVDropdownInput required disabled={disableEmployeeDetails} label="Company" column={4} completeMethod={completeMethodEC} control={control} name="company" error={errors.company?.vendor_Company_ID?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Employer Company" />
                                <JVInput required disabled={disableEmployeeDetails} label="Contact Name" placeholder="Contact Name" column={4} control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                                <JVInputMask required disabled={disableEmployeeDetails} label="Employer Phone" mask="(999) 999-9999" column={4} placeholder="Employer Phone" control={control} name="phone_No" error={errors.phone_No?.message} />
                            </div>
                        </AccordionTab>}

                        <AccordionTab header="Education & Other Details:">
                            <div className="p-fluid formgrid grid">
                                <JVInput placeholder="Degree" column={3} control={control} name="degree" error={errors.degree?.message} />
                                <div className="field col-12 md:col-4">
                                    <div className="p-inputgroup">
                                        <AutoComplete suggestions={universities}
                                            completeMethod={completeMethodUniversities} field='university_Name' value={university}
                                            placeholder="Search/Type University" onChange={(e) => setUniversity(e.value)} />
                                    </div>
                                    <small className="p-error" >{errors.university_Name?.message}</small>
                                </div>
                                <JVInput placeholder="Passing Year" column={3} control={control} name="passoutYear" error={errors.passoutYear?.message} />
                                <JVDropdownInput column={3} completeMethod={completeMethodCountries} control={control} name="country" error={errors.country?.country_ID?.message} options={countries} optionLabel="country_Name" placeholder="Search Country" />

                                {/* <JVDate maxDate={new Date} placeholder="Date Of Birth" column={3} control={control} name="dob" error={errors.dob?.message} /> */}
                                <div className="field col-12 md:col-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <JVInputMask mask="99" column={3} placeholder="MM" control={control} name="dobmm" />
                                    <JVInputMask mask="99" column={3} placeholder="DD" control={control} name="dobdd" />
                                    <JVInputMask mask="9999" column={3} placeholder="YYYY" control={control} name="dobyyyy" />
                                </div>

                                <JVInput placeholder="SSN" column={3} type={"number"} control={control} name="ssn" error={errors.ssn?.message} />
                                <JVInput placeholder="Linkedin" column={3} control={control} name="linkedin" error={errors.linkedin?.message} />

                                <JVDropdown column={3} control={control} name="submissionType" error={errors.submissionType?.message} options={CblType} optionLabel="name" optionValue="name" placeholder="--Select JobType--" />
                                <JVInput placeholder="Salary" type={"number"} column={3} control={control} name="annual_Salary" error={errors.annual_Salary?.message} />
                            </div>
                        </AccordionTab>

                    </Accordion>

                    <div className="field col-12 md:col-4">
                        <FileUpload chooseLabel="Choose Resume" mode="basic" name="resume" accept=".docx" auto customUpload uploadHandler={resumeUploade} />
                    </div>
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button loading={loading} disabled={loading} label="SAVE" type="submit" style={{ width: '100px' }} ></Button>
                        <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={() => { reset({}); setUniversity(undefined); }} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}